// `color` is Semantic's <Label color>; `tone` is adminUi's <Badge tone>. Both are here so
// the two renderings of the same status cannot drift — the admin list uses Badge, the
// trainee-facing pages still use Label.
export const SUPPORT_TICKET_STATUS = {
  open: { text: "접수됨", color: "grey", tone: "gray" },
  replied: { text: "답변됨", color: "blue", tone: "blue" },
  closed: { text: "종료", color: "green", tone: "green" },
};

export const getSupportTicketStatusLabel = (status) =>
  SUPPORT_TICKET_STATUS[status] || { text: status, color: "grey", tone: "gray" };

export const isReporterReply = (reply, ticket) =>
  reply.author?.id === ticket.author?.id;
